import {
  Breakpoints,
  Container,
  ContainerGutter,
  ContainerPadding,
  Layout,
  styled,
  CTA,
  BreakpointWrapper,
} from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { CloseHandleV2, FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import React, { useRef } from 'react';
import { useFeatureServices } from 'src/feature-app/hooks';
import { CarlineEquipments, CarlineEquipmentsProps } from '.';

const FixedDiv = styled.div`
  display: 'block';
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  border-radius: 15px;
  z-index: 2;
`;

const FixedDivDesktop = styled(FixedDiv)`
  position: absolute;
`;

const ActionWrapper = styled.div`
  
  & button{
    min-height: 32px;
    padding: 4px 16px;
    min-width: 0px; 
  }

  & div {
    top: 0;
  }
`;

export const CarlineEquipmentsLayer = (props: CarlineEquipmentsProps) => {
  const { equipments, offer } = props;
  const layerManager = useFeatureServices()['layer-manager'];
  const fixedDivRef = useRef<HTMLDivElement>(null);
  const topRef = useRef<HTMLDivElement>(null);
  const layerRef = useRef(null);

  const scrollTop = (element: HTMLDivElement) => {
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ block: 'start' });
      }, 0);
    }
  };

  const onCloseCallback = () => {
    if (fixedDivRef.current) {
      fixedDivRef.current.style.display = 'none';
    }
    if (topRef.current) {
      setTimeout(() => {
        topRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
      }, 800);
    }
  };

  const renderCerrarDiv = () => {
    return (
      <FixedDiv ref={fixedDivRef} className='fixed-div'>
        <ActionWrapper>
          <CTA
            tag='button'
            emphasis='secondary'
            size='small'
            onClick={() => {
              layerRef.current.close();
              onCloseCallback();
            }}
            icon={<Close variant='small' />}
          >
            Cerrar
          </CTA>
        </ActionWrapper>
      </FixedDiv >
    );
  };

  const handlePromoClick = () => {
    if (equipments) {
      if (window.innerWidth < 559) {
        const layer = layerManager.openFocusLayer(
          renderPromo,
          {},
          { size: FocusLayerSizeV2.B, userCloseable: true, closeButton: renderCerrarDiv(), onClose: onCloseCallback }
        );
        layerRef.current = layer;
      } else {
        const layer = layerManager.openContentLayerV2(renderPromo, {}, {
          id: `Equipamiento-${offer.carline.title}`, 
          closeButtonLabel: "Cerrar ver equipamiento", 
          contentHeadline: "",
        })
        layerRef.current = layer;
      }
    }
  };


  const renderPromo = (state: any, close: CloseHandleV2<any, any>) => {
    // El CMS no desmonta el div del closeButton y lo tenemos que ocultar manualmente.
    if (fixedDivRef.current) {
      fixedDivRef.current.style.display = 'block';
    } else {
      document.getElementsByClassName('fixed-div')[0]?.style?.display = 'block';
    }

    return (
      <>
        <div
          ref={(e) => {
            scrollTop(e);
          }}
        />
        <div style={{ position: 'relative' }}>
          <Layout
            appearance={{
              [Breakpoints.default]: [
                { name: '.', columns: 2 },
                { name: 'a', columns: 20 },
                { name: '.', columns: 2 },
              ],
              [Breakpoints.b960]: [
                { name: '.', columns: 4 },
                { name: 'a', columns: 16 },
                { name: '.', columns: 4 },
              ],
            }}
          >
            <Container
              padding={{
                top: ContainerPadding.dynamic0200,
                bottom: { 0: ContainerPadding.dynamic0300, 560: ContainerPadding.dynamic0200 },
              }}
              gutter={ContainerGutter.static400}
              stretchContent
            >
              <CarlineEquipments equipments={equipments} />
            </Container>
          </Layout>
        </div>
      </>
    );
  };

  return (
    <div  ref={topRef} >
      <CTA
        tag='button'
        emphasis='tertiary'
        size='small'
        onClick={handlePromoClick}
        ariaLabel='aria label'
      >
        <b>Ver equipamiento</b>
      </CTA>
    </div>
  );
};
